import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public LoaderComponent = LoaderComponent;
  title = 'access-hr';

  constructor(private translate: TranslateService){}

  ngOnInit(): void {
    this.translate.addLangs(['en', 'hi']);
    if (localStorage.getItem('lang')) {
      this.translate.setDefaultLang(localStorage.getItem('lang'));
      this.translate.use(localStorage.getItem('lang'));
    } else {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
      localStorage.setItem('lang', 'en');
    }

    // let popup = window.open();
    // if(popup==null){
    //     alert("Please enable popup");
    // }

  }

}
